var render, staticRenderFns
import script from "./SaveAssessmentCard.vue?vue&type=script&lang=js&"
export * from "./SaveAssessmentCard.vue?vue&type=script&lang=js&"
import style0 from "./SaveAssessmentCard.vue?vue&type=style&index=0&id=53d86545&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports